import ApiRequest from './apiRequest';

class NotificationsService {
  static async getNotifications() {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `notifications/my`}
    );
    return data;
  };

  static async markNotificationsAsRead() {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `notifications/my`, noResponse: true}
    );
    return data;
  };
}

export default NotificationsService;
